
<form #form="ngForm">
  <div class="input-group">
    <input class="form-control" type="text" name="value" required [placeholder]="placeholder ?? &quot;&quot;" [(ngModel)]="value">
    <div class="input-group-append">
      <button class="btn btn-secondary m-0" type="submit" [disabled]="!value" (click)="submit()"><i class="far fa-plus"></i><span>{{verb || ("Add"|translate)}}</span></button>
    </div>
  </div>
</form>